export default __webpack_public_path__ + "assets/whatsappIcon.eb478217.png";